import { ref } from 'vue'
import store from '../plugins/vuex'

import Blackout from '../models/Blackout'
import Organization from '../models/Organization'
import Location from '../models/Location'
import Product from '../models/Product'
import User from '../models/User'
import UserSolution from '../models/UserSolution'

class GlobalDataService {

  // Do not modify these values from outside this class!
  // They're only public so that Vue's reactivity system can detect when
  // they've changed (e.g., in App.vue).
  // If we can find a way to do that without making them publicly mutable, then
  // we should.
  loading = ref(false)
  loaded = ref(false)

  isLoaded() {
    return this.loaded.value
  }

  load() {

    this.loading.value = true

    return Promise
      .all([
        Blackout.fetchAll(),
        Organization.fetchAll(),
        User.fetchAll(),
        UserSolution.fetchByUserID(store.state.auth.user.ID),
        Location.fetchAll(),
        Product.fetchAll(),
      ])
      .then(() => {
        this.loaded.value = true
      })
      .catch((error) => {
        console.error(error)
        // NotificationService.error('Failed loading global data!')
      })
      .finally(() => {
        this.loading.value = false
      })

  }

  purge() {
    store.dispatch('entities/deleteAll') // delete all Vuex ORM entities
    this.loaded.value = false
  }

}

export default new GlobalDataService()
